import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ap_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Cache-busting: prevent stale GET responses (ingress/CDN/browser cache)
  if ((cfg.method || "get").toLowerCase() === "get") {
    cfg.params = { ...(cfg.params || {}), _t: Date.now() };
    cfg.headers["Cache-Control"] = "no-cache";
  }
  return cfg;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export default API;
